module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"articles":{"action":"Suggest content","empty_state":"Would you also like to publish an article on CAPinside? Feel free to write us a message with your topic suggestions.","title":"Articles"}}}}}}}')
  delete Component.options._Ctor
}
